<script lang="ts">
    export let type: 'h1' | 'h2' | 'h3';

    function getFontSize(): string {
        if (type === 'h1') {
            return '24px';
        }

        if (type === 'h2') {
            return '18px';
        }

        return '14px';
    }
</script>

<svelte:element this="{type}"
                style:font-size="{getFontSize()}"
                style:margin="0"
                style:font-weight="500">

    <slot/>
</svelte:element>